"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaYupConfigDeltaClass = exports.yupConfigDeltaClass = void 0;
const yup = __importStar(require("yup"));
const enums_1 = require("../../enums");
exports.yupConfigDeltaClass = yup.object({
    app_dia_envio: yup
        .number()
        .notRequired()
        .nullable()
        .default(undefined)
        .label('Enviar notificação de Adimplência no dia'),
    app_integrado: yup
        .mixed()
        .oneOf([...Object.values(enums_1.EDeltaClassIntegracao), undefined, null])
        .default(undefined)
        .label('App de terceiros integrado'),
    app_nome_nota: yup
        .string()
        .notRequired()
        .nullable()
        .when('app_not_boletim', {
        is: true,
        then: yup.string().required(),
    })
        .default(undefined)
        .label('Nomenclatura para notas'),
    // TODO: discutir isso
    app_not_avisos: yup.boolean().required().default(false).label('Habilitar o envio de notificação de Avisos'),
    app_not_boletim: yup.boolean().required().default(false).label('Habilitar o envio de notificação de Boletim'),
    app_not_calendario: yup.boolean().required().default(false).label('Habilitar o envio de notificação de Avaliações'),
    app_not_catraca: yup.boolean().required().default(false).label('Habilitar o envio de notificação de Catraca'),
    app_not_chat: yup.boolean().required().default(false).label('Habilitar o envio de notificação de Conversas'),
    app_not_mensagem: yup.boolean().required().default(false).label('Habilitar o envio de notificação de Publicações'),
    app_not_fin_adiantado: yup
        .boolean()
        .required()
        .default(false)
        .label('Enviar notificação financeira para faturas prestes a vencer'),
    app_not_fin_adiantado_qtd: yup
        .number()
        .notRequired()
        .nullable()
        .default(undefined)
        .when('app_not_fin_adiantado', {
        is: true,
        then: yup.number().required().positive().integer(),
    })
        .label('Número de dias de antecedência'),
    app_not_fin_atrasado: yup
        .boolean()
        .required()
        .default(false)
        .label('Enviar notificação financeira para faturas atrasadas'),
    app_not_fin_atrasado_qtd: yup
        .number()
        .notRequired()
        .nullable()
        .default(undefined)
        .when('app_not_fin_atrasado', {
        is: true,
        then: yup.number().required().positive().integer(),
    })
        .label('Número de dias de atraso'),
    app_not_fin_dia: yup.boolean().required().default(false).label('Enviar notificação financeira no dia de vencimento'),
    app_not_financeiro: yup.boolean().required().default(false).label('Habilitar o envio de notificação do Financeiro'),
    // TODO: discutir isso
    app_not_material: yup.boolean().required().default(false).label('Habilitar o envio de notificação de Material'),
    app_not_message: yup.boolean().required().default(false).label('Habilitar o envio de notificação de Adimplência'),
    app_not_notas: yup.boolean().required().default(false).label('Habilitar o envio de notificação de Notas Parciais'),
    app_not_ocorrencias: yup.boolean().required().default(false).label('Habilitar o envio de notificação de Ocorrências'),
    app_notificacoes: yup
        .boolean()
        .required()
        .default(false)
        .label('Habilitar o envio de notificações para o DeltaClass'),
    app_text_not_message: yup
        .string()
        .notRequired()
        .nullable()
        .default(undefined)
        .when('app_not_message', {
        is: true,
        then: yup.string().required(),
    })
        .label('Mensagem para o envio de notificação de Adimplência'),
});
exports.schemaYupConfigDeltaClass = exports.yupConfigDeltaClass.shape({});
